const header = document.querySelector(".header");
// set css variable for header height

function recalculateHeaderHeight() {
  if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
  }
}

// on resize, update header height
window.addEventListener("resize", () => {
  recalculateHeaderHeight();
});

recalculateHeaderHeight();
